import { Box, styled } from '@mui/material';
import { PropsWithChildren } from 'react';

const Content = styled(Box)({
  width: '100%',
  height: '100%',
  position: 'relative',
});

const Inner = styled(Box)(({ theme }) => ({
  width: '100%',
  height: `calc(100% - ${theme.spacing(theme.spacingSizes.xl)})`, // must match the margin of the action bar
}));

const ActionBar = styled(Box)(({ theme }) => ({
  padding: theme.spacing(theme.spacingSizes.md, theme.spacingSizes.lg),
  borderTop: `1px solid ${theme.palette.borderColor.main}`,
  position: 'sticky',
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: theme.palette.background.paper,
  margin: theme.spacing(
    0,
    -theme.spacingSizes.xl,
    -theme.spacingSizes.xl,
    -theme.spacingSizes.xl,
  ),
  zIndex: 10000,
}));

const FullHeightView: React.FC<
  PropsWithChildren<{ actionBar?: React.ReactNode }>
> = ({ children, actionBar }) => {
  return (
    <Content>
      <Inner>{children}</Inner>
      {actionBar ? <ActionBar>{actionBar}</ActionBar> : null}
    </Content>
  );
};

export default FullHeightView;
